import React, { Component } from "react";
import { ChangeTitle } from "../util/ChangeTitle";
import "./footer.css"
export default class End extends Component {
  render() {
    ChangeTitle("Welcome, financeFrenzy!");
    return (
      <div class="container-fluid d-md-flex py-4">
        <div class="me-md-auto text-center text-md-start">
          <div class="copyright">
            &copy;
            <strong>
              <span>financeFrenzy, </span>
            </strong>
             ©2021 
             Headquarters: Charlotte,NC
            <p><a className="foot-link" style={{color:"rgb(48, 140, 201)"}} href="mailto:selva.financefrenzy@gmail.com">Email: selva.financefrenzy@gmail.com </a><a className="foot-link" style={{color:"rgb(48, 140, 201)"}} href="tel: +1-972-998-7537 "> | Phone:+1-972-998-7537 </a></p>
         
          </div>
          <div  class="credits">
            Designed by <a className="foot-link" style={{color:"rgb(48, 140, 201)"}} href="https://www.linkedin.com/company/96366383">Learn TEK In</a>
          </div>
        </div>
        <div class="social-links text-center text-md-end pt-3 pt-md-0">
          <a href="#" class="twitter">
            <i class="bx bxl-twitter"></i>
          </a>
          <a href="#" class="facebook">
            <i class="bx bxl-facebook"></i>
          </a>
          <a href="https://www.instagram.com/" class="instagram">
            <i class="bx bxl-instagram"></i>
          </a>
          <a href="#" class="google-plus">
            <i class="bx bxl-skype"></i>
          </a>
          <a href="https://www.linkedin.com/in/" class="linkedin">
            <i class="bx bxl-linkedin"></i>
          </a>
        </div>
      </div>
    );
  }
}
